import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

const DeleteProfilePopup: React.FC<{ close: any }> = ({ close }) => {
    // const [deleteAddress, deleteMyAddress] = useState()

    const notify = (message: string) => toast(message);

    const handleQuickBookClose = () => {
        close();
    }

    const base_url = process.env.REACT_APP_BACKEND_URL;

    const token = localStorage.getItem("token");

    const navigate = useNavigate();

    function handleLogout() {
        localStorage.clear();
        navigate("/login")
    }

    function handleProfileDelete() {
        const headers = {
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        }

        axios.post(`${base_url}/api/delete_user_profile`, {}, {
            headers: headers
        }).then(e => {
            if (e.data.Response.response_code == "1" && e.data.Response.response_message == "profile deleted successfully") {
                notify(e.data.Response.response_message)
                handleLogout();
                return true
            }
            else {
                notify(e.data.Response.response_message)
                window.location.reload();

                // setGenError(e.data.Response.response_message);
                return false
            }
        })
    }

    return (

        <div>
            <div className="custom-modal-class modal in" id="app_download_success_popup" style={{ display: "block"}}>
                <div className="vertical-alignment-helper">
                    <div className="modal-dialog modal-md modal-dialog-centered">
                        <div className="modal-content">

                            <div className="modal-body">
                                <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={handleQuickBookClose}></button>
                                <h3 className="text-center">Confirm Delete?</h3>

                                {/* <h3>Thank you for showing interest in our app. You will get the link via SMS soon.</h3>
                                <input type="submit" value="Close" data-bs-dismiss="modal" onClick={handleThankAppDownloadPopupClose} /> */}
                                <form id="quick-order-form" >
                                    <a className="btn btn-success me-1" data-bs-dismiss="modal" onClick={handleQuickBookClose} >No</a>
                                    <a className="btn btn-danger ms-1" onClick={handleProfileDelete}>Yes</a>
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default DeleteProfilePopup;